<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>资金管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/checkOpBu')">保证金修改审核</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='代理信息'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入姓名或者手机号"
            >

            </el-input>
          </el-form-item>

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="filters.status"
              clearable
            >
              <el-option
                label="申请中"
                value="1"
              ></el-option>
              <el-option
                label="成功"
                value="2"
              ></el-option>
              <el-option
                label="失败"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select
              v-model="filters.infoType"
              clearable
            >
              <el-option
                label="加"
                value="1"
              ></el-option>
              <el-option
                label="减"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          style="width: 100%"
          :height="tableHeight"
          :header-cell-class-name='objectSpanMethod'
        >


          <el-table-column
            prop="t_name"
            label="申请人"
          >
          </el-table-column>

          <el-table-column
            prop="username"
            label="代理姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="代理手机号"
          >
          </el-table-column>

          <el-table-column
            :formatter="formatterRoleType"
            prop="role_type"
            label="代理身份"
          >
          </el-table-column>

          <el-table-column
            prop="info_type"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.info_type == 1">加</span>
              <span v-if="scope.row.info_type == 2">减</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="deposit"
            label="修改金额"
          >
          </el-table-column>


          <el-table-column
            prop="create_time"
            label="申请时间"
          >
          </el-table-column>


          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >成功</el-tag>
              <el-tag
                v-if="scope.row.status == 1"
                disable-transitions
              >申请中</el-tag>
              <el-tag
                v-if="scope.row.status == 3"
                type="danger"
                disable-transitions
              >失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column

            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template v-if="hasPower('50081991') && scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >通过</el-button>
                <el-button v-if="hasPower('50081991')"
                  @click="upHouseStatus(scope.row,3)"
                  type="text"
                  size="small"
                >拒绝</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "judgeList",
  created() {},

  data() {
    return {
      totalMoney: 0,
      listLoading: false,
      picList: [],
      filters: {
        infoType:null,
        status: null,
        startTime: null,
        title: null,
        userId: null,
        endTime: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        return "康减系列VIP会员";
      } else if (row.role_type == -0.4) {
        return "康减系列荣誉会员";
      } else if (row.role_type == -0.3) {
        return "康减系列高级会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 5) {
        word = "总经销商";
      } else if (row.role_type == 2.2) {
        word = "合伙人";
      } else if (row.role_type == 4.2) {
        word = "董事";
      } else if (row.role_type == 5.1) {
        word = "区域总监";
      } else if (row.role_type == 5.2) {
        word = "城市加盟商";
      } else if (row.role_type == 4.8) {
        word =  "经销商";
      }
      if (row.special_status == 2) {
        word = word + '-' + '特殊';
      }
      return word;
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/op_deposit_list_excle?token=" +
        localStorage.getItem("api_token");
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.title) {
        url = url + "&username=" + that.filters.title;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.info_type) {
        url = url + "&infoType=" + that.filters.info_type;
      }
      top.location.href = url;
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 3
            };
            API.check_op_deposit(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  console.error(err);
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 2
            };
            API.check_op_deposit(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.error(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.title) {
        params.userInfo = that.filters.title;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }

      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }

      that.listLoading = true;
      API.op_deposit_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.totalMoney = result.result.data;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  if (result.result.list[i].create_time != null) {
                    result.result.list[i].create_time = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].create_time)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/checkOpDeposit.vue